<template>
  <div class="mt-2">
    <b-row class="justify-content-start align-items-center">
      <b-col
        v-for="(link, n) in links"
        :key="n"
        cols="4"
        v-if="checkIsItemGroup(link)"
      >
        <b-card  style="height: 260px">
          <b-card-title class="mb-3 d-flex align-items-center">
            <feather-icon size="16" class="mr-50" icon="GridIcon" />
            {{ link.title }}
          </b-card-title>
          <b-form-row class="mt-5">
            <template v-for="(btn, n) in link.btns">
              <b-col v-if="checkIsItem(btn.slug)" :key="n" cols="4">
                <router-link :to="btn.path">
                  <div
                    class="ngos-link d-flex flex-column align-items-center px-2"
                  >
                    <feather-icon class="my-1" size="45" :icon="btn.icon" />

                    <h5 style="white-space: pre-line" class="text-white">
                      {{ btn.label }}
                    </h5>
                  </div>
                </router-link>
              </b-col>
            </template>
          </b-form-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BFormRow,
  BContainer,
  BCol,
  BAvatar,
  BCard,
  BCardTitle,
  BCardText,
  BButton,
} from "bootstrap-vue";
import AuthHelpers from "@/utils/auth-helpers";

export default {
  components: {
    BRow,
    BFormRow,
    BContainer,
    BCol,
    BAvatar,
    BCard,
    BCardTitle,
    BCardText,
    BButton,
  },

  data() {
    return {
      links: [
        {
          title: "الأسئلة الأكثر شيوعاً",
          btns: [
            {
              slug: "ministry_Q&A",
              label: "الأسئلة و الأجوبة",
              path: { name: "settings-faq" },
              icon: "HelpCircleIcon",
            },
            {
              slug: "ministry_question_categories",
              label: "تصنيفات الأسئلة",
              path: { name: "settings-faq-categories" },
              icon: "LayersIcon",
            },
          ],
        },
        {
          title: "تخصيص",
          btns: [
            {
              slug: "ministry_indexes",
              label: "الفهارس",
              path: { name: "settings-indexes" },
              icon: "BookmarkIcon",
            },
            {
              slug: "ministry_instructions",
              label: "الإرشادات",
              path: { name: "settings-instructions" },
              icon: "ListIcon",
            },
            {
              slug: "ministry_annual_holidays",
              label: "أيام العطل الرسمية",
              path: { name: "settings-holidays" },
              icon: "CalendarIcon",
            },

            
          ],
        },
        {
          title: "المستخدمين و الأدوار",
          btns: [
            {
              slug: "ministry_users_rp",
              label: "المستخدمين",
              path: { name: "settings-users" },
              icon: "UsersIcon",
            },
            {
              slug: "ministry_roles_rp",
              label: "الأدوار",
              path: { name: "settings-roles" },
              icon: "CheckCircleIcon",
            },
            {
              slug: "ministry_users_availability",
              label: "توفر المستخدم",
              path: { name: "settings-usersAvailability" },
              icon: "UnlockIcon",
            },
            // {
            //   slug:"ministry_permissions_rp",
            //   label: "الصلاحيات",
            //   path: "/",
            //   icon: "UnlockIcon",
            // },
          ],
        },
        {
          title: "إدارة صفحات الجمهور",
          btns: [
            {
              slug: "ministry_slider",
              label: "معرض الصور",
              path: { name: "settings-image-slider" },
              icon: "ImageIcon",
            },
            {
              slug: "ministry_regulations",
              label: "المرجعيات القانونية",
              path: { name: "settings-regulations" },
              icon: "BookOpenIcon",
            },
            {
              slug: "ministry_events",
              label: "الفعاليات",
              path: { name: "settings-events" },
              icon: "CalendarIcon",
            },
          ],
        },
        {
          title: "إدارة المعاملات",
          btns: [
            {
              slug: "ministry_transaction_types",
              label: " أنواع المعاملات",
              path: { name: "transactions-description" },
              icon: "FileTextIcon",
            },
            {
              slug: "ministry_action_types",
              label: " إجرائيات المعاملات",
              path: { name: "transactions-actions" },
              icon: "FileTextIcon",
            },
          ],
        },
        // {
        //   title: "شمل",
        //   btns: [
        //     {
        //       label: "الاستمارات",
        //       path: { name: "settings-shaml-forms" },
        //       icon: "FileTextIcon",
        //     },
        //   ],
        // },
      ],
    };
  },

  methods: {
    checkIsItem(slug) {
      return AuthHelpers.canNavigate(slug);
    },
    checkIsItemGroup(item) {
      return item.btns.some((el) => AuthHelpers.canNavigate(el.slug));
    },
  },
};
</script>

<style lang="scss" scoped>
.ngos-link {
  background-color: var(--primary);
  padding: 4px;
  color: var(--white);
  text-align: center;
  white-space: nowrap;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.25s ease;
  height: 150px;
  &:hover {
    opacity: 0.85;
    -webkit-box-shadow: 0 8px 25px -8px var(--primary);
    box-shadow: 0 8px 25px -8px var(--primary);
  }

  &:active {
    background-color: #043d6e;
  }
}
</style>
